import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";

const CreditPayTable = ({ showTable, historyData = null ,
  shouldGenerateReport,
  setShouldGenerateReport,calcDone}) => {
  const {textData} = useLocale();
    const [reportData, setReportData] = useState([]);
    const { loanAmmount, intrestRate, monthlyPay, monthsToPayoff } = useSelector((state) => state.creditCalculator);
    
    useEffect(() => {
        if(historyData){
            generateHistoryreport();
        }
       
    }, [showTable, loanAmmount, intrestRate, monthlyPay, monthsToPayoff,historyData]);

 useEffect(() => {
    if (shouldGenerateReport) {
      generateReportData();
      setShouldGenerateReport(false);
    }else if (!calcDone) {
    setReportData([]); 
  }
  generateHistoryreport();
}, [shouldGenerateReport, calcDone, historyData]);

    const generateHistoryreport = () =>{
        if(!Array.isArray(historyData) || historyData.length === 0) {
            return;
        }
        const creditData = historyData[0];
        const principal = (creditData.totalInvestment);
        const annualInterestRate = creditData.annualInterestRate;
        const monthlyPayment = creditData.monthlyPayment;
        const monthlyInterestRate = creditData.annualInterestRate / 100;
        
        let balance = principal;
        let month = 0;
        let reportData = [];
        
        while (balance > 0 ) {
          const monthlyInterest = balance * monthlyInterestRate;
          
          const principalPayment = Math.min(monthlyPayment - monthlyInterest, balance);
          const adjustedPayment = monthlyInterest + principalPayment;
          let actualPayment;
    if (principalPayment >= balance) {
      // Last payment: interest + remaining balance
      actualPayment = monthlyInterest + balance;
    } else {
      // Regular payment
      actualPayment = monthlyPayment;
    }         
     balance -=  principalPayment;

    
          if (balance < 0.01) balance = 0;
          
          reportData.push({
            Month: month +1 ,
            payment: actualPayment,
            intrestPaid: monthlyInterest,
            principlePaid: principalPayment,
            remainingBalance: balance
          });
          
          month++;
        }
        
        setReportData(reportData);

    }
    const generateReportData = () => {
      const principal = loanAmmount;
      const annualInterestRate = intrestRate;
      const monthlyPayment = monthlyPay;
      const monthlyInterestRate = annualInterestRate / 100;
      
      let balance = principal;
      let month = 0;
      let reportData = [];
      
      while (balance > 0) {
        const monthlyInterest = balance * monthlyInterestRate;
        const principalPayment = Math.min(monthlyPayment - monthlyInterest, balance);
        
        // Calculate the actual payment for this month
        let actualPayment;
        if (principalPayment >= balance) {
          // Last payment: interest + remaining balance
          actualPayment = monthlyInterest + balance;
        } else {
          // Regular payment
          actualPayment = monthlyPayment;
        }
        
        balance -= principalPayment;
        
        if (balance < 0.01) balance = 0;
        
        reportData.push({
          Month: month + 1,
          payment: actualPayment,
          intrestPaid: monthlyInterest,
          principlePaid: principalPayment,
          remainingBalance: balance
        });
        
        month++;
      }
      
      setReportData(reportData);
    };

    const columns = [
        { key: 'Month', label:`${textData.tableLabels.month} (${textData.currency})`, format: (value) => value },
        { key: 'payment', label: `${textData.tableLabels.payment} (${textData.currency})`, format: (value) => `${FormatIndianNumber(Math.round(value))}` },
        { key: 'intrestPaid', label: `${textData.tableLabels.intrestPaid} (${textData.currency})`, format: (value) => `${FormatIndianNumber(Math.round(value))}` },
        { key: 'principlePaid', label:  `${textData.tableLabels.principlePaid} (${textData.currency})`, format: (value) => `${FormatIndianNumber(Math.round(value))}` },
        { key: 'remainingBalance', label: `${textData.tableLabels.remainingBalance} (${textData.currency})`, format: (value) => `${FormatIndianNumber(Math.round(value))}` }
    ];

    return (
        <TableLayout
            showTable={showTable}
            title={`${textData.filterDropDown.creditCardPayoffCalc} ${textData.report}`}
      data={reportData}
            columns={columns}
            analyticsEventName="download_pl_report"
            reportTitle={textData.reportTitle.creditReport}
            fileName="creditcard-payoff_detail"   
        />
    )
}

export default CreditPayTable;